import type { LoaderFunctionArgs } from 'react-router-dom';
import { redirect } from 'react-router-dom';

import { logger } from '@/shared';
import { stashInviteToken } from '@/shared/lib/invite-token';

export async function rootLayoutLoader({ request }: LoaderFunctionArgs): Promise<null> {
  const url = new URL(request.url);
  const inviteKey = url.searchParams.get('invite_key');
  if (!inviteKey) {
    return null;
  }

  stashInviteToken(inviteKey);
  url.searchParams.delete('invite_key');

  logger.info('router.inviteKey.stashed', {
    source: 'app/router',
    pathname: url.pathname,
  });

  throw redirect(`${url.pathname}${url.search}`);
}
